/**
 * Voucher flow error codes.
 */
export enum VoucherErrorCode {
  FETCH_DATA_FAILED = 'error.voucher.fetch_data.failed',
}
